import { ErrorMessage, Spinner } from "../../../../../widgets";
import { FC, useCallback } from "react";
import { FetchStatus, Property } from "../../../../../base/types";

import { CheckBoxLabel } from "./CheckBoxLabel";
import { IControlAttributes } from "../../../../../base/models";
import clsx from "clsx";
import { useCheckBoxProperties } from "./CheckBoxProperties";

export const DraftCheckBoxComponent: FC<IControlAttributes> = ({
    control, className, props
}) => {
    const { status, properties, bindings, error } = useCheckBoxProperties(props);
    const { label, required, title } = properties || {}
    const containerClass = label ? className : ''
    const inputClass = label ? '' : className

    const getValue = useCallback(() => {
        if (!bindings) return;

        const binding = bindings.getBinding(Property.InitValue);
        if (!binding || !binding.boundValue) return;

        switch (binding.type) {
            case "Const":
                return { value: binding.boundValue as (boolean | undefined) }
            case "Expression":
                return { text: `${binding.boundValue?.query}`, value: binding.boundValue as (boolean | undefined) }
            case "Field":
                return { text: `{${binding.boundValue}}`, value: binding.boundValue as (boolean | undefined) }
        }
    }, [bindings])

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    const { value, text } = getValue() || {};
    return <CheckBoxLabel
        htmlFor={control.controlId}
        title={title}
        label={label}
        required={required}
        className={containerClass}
    >
        <div className={clsx(inputClass,
            "form-check-input",
            { "draft-checkbox": !value, "draft-checkbox-checked": value })}
        />
        <div className="badge badge-secondary rounded-0 fs-9 mx-1 align-self-start">{text}</div>
    </CheckBoxLabel>
}
